import React from 'react';
import { Dashboard } from '../components';

const dataProviderName = 'bis/biIntegrated';

const Default = () => {
    const defaultFilters = { items: [] };

    return (
        <Dashboard dataProviderName={dataProviderName} filters={defaultFilters} />
    );
};

export default Default;
